<template>
  <b-field :label="label">
    <b-select
      placeholder="Language"
      icon="flag"
      v-model="language"
      class="is-fullwidth"
      @change.native="changeLanguage"
    >
      <option value="en-US"
        ><b-icon icon="flag" size="is-small"></b-icon>English</option
      >
      <option value="es-ES"
        ><b-icon icon="flag" size="is-small"></b-icon>Español</option
      >
    </b-select>
  </b-field>
</template>

<script>
import language from "@/mixins/language";

export default {
  mixins: [language],
  props: {
    label: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      language: "en-US"
    };
  },
  created() {
    this.language = this.setStoredLanguage();
  },
  methods: {
    changeLanguage(value) {
      this.$i18n.locale = this.language;
      window.localStorage.setItem("tomin-language", this.language);
    }
  }
};
</script>
